export enum appURLs {
  HOME = "/",
  APP = "/app",
  MY_CROPWISE = "/my-cropwise",
  TRIALS = "/trials",
  PROTOCOLS = "/protocols",
}
